import { FC } from 'react';
import { uploadFileNamesMap, UploadFileTypeEnum } from '@dynamika-shared/types/inventory';

type UploadDescriptionProps = {
  fileType: UploadFileTypeEnum | null;
};

export const UploadDescription: FC<UploadDescriptionProps> = ({ fileType }) => {
  const formatedFileType = uploadFileNamesMap[fileType as UploadFileTypeEnum] ?? fileType;

  switch (fileType) {
    case UploadFileTypeEnum.DICOM:
      return (
        <span className='text-1624 font-medium text-chineseBlack'>
          Drop your {formatedFileType} study here, or{' '}
          <span className='ml-0.5 font-medium text-vividTangelo'>
            click to browse
          </span>
          <span> only .zip files</span>
        </span>
      );
    case UploadFileTypeEnum.DICOMIZED_PDF:
    case UploadFileTypeEnum.DICOMIZED_CSV:
      return (
        <span className='text-1624 font-medium text-chineseBlack'>
          Drop your {formatedFileType} study here, or{' '}
          <span className='ml-0.5 font-medium text-vividTangelo'>
            click to browse
          </span>
        </span>
      );

    default:
      return (
        <span className='text-1624 font-medium text-chineseBlack'>
          Drop your {fileType} study here, or{' '}
          <span className='ml-0.5 font-medium text-vividTangelo'>
            click to browse
          </span>
          <span> only .zip files</span>
        </span>
      );
  }
};
